import React from 'react';
import { Toaster as HotToaster } from 'react-hot-toast';

/**
 * Thin wrapper around react-hot-toast's Toaster.
 * Props are forwarded so callers can pass position, etc.
 */
const Toaster = (props) => (
  <HotToaster
    containerStyle={{ top: 16 }}
    toastOptions={{
      duration: 4000,
      style: {
        background: 'hsl(var(--card))',
        color: 'hsl(var(--foreground))',
        border: '1px solid hsl(var(--border))',
        borderRadius: '0.75rem',
        fontSize: '0.875rem',
      },
      success: {
        iconTheme: { primary: 'hsl(var(--success, 142 76% 36%))', secondary: '#fff' },
      },
      error: {
        iconTheme: { primary: 'hsl(var(--destructive))', secondary: '#fff' },
      },
    }}
    {...props}
  />
);

export default Toaster;
